var React = require('react');

function LookingGlassInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Menu","transform":"translate(-915.000000, -13.000000)","fillRule":"nonzero","stroke":"#FFFFFF","strokeWidth":"1.6"},React.createElement("g",{"id":"search-icon"},React.createElement("g",{"transform":"translate(916.000000, 14.000000)"},[React.createElement("circle",{"id":"Oval","cx":"4.8","cy":"4.8","r":"4.8","key":0}),React.createElement("path",{"d":"M8.33333333,8.4 L11.6666667,11.6","id":"Line","strokeLinecap":"square","key":1})])))));
}

LookingGlassInline.defaultProps = {"width":"14px","height":"14px","viewBox":"0 0 14 14","version":"1.1"};

module.exports = LookingGlassInline;

LookingGlassInline.default = LookingGlassInline;
